import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class ClientDetailVm {
	clientId: number;
	clientName?: string;
	isActiveStr?: string;
	isUpdatedOffline: boolean;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'clientId': new UntypedFormControl(0, [...(validators['clientId'] ?? []), ...[Validators.required]]),
			'clientName': new UntypedFormControl(null, [...(validators['clientName'] ?? []), ...[]]),
			'isActiveStr': new UntypedFormControl(null, [...(validators['isActiveStr'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['clientName', {"orderId":0,"sortColumn":"clientName","searchColumn":"clientName","includeInExcel":true,"exportColumn":null,"displayName":"Client Name","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['isActiveStr', {"orderId":1,"sortColumn":"isActiveStr","searchColumn":"isActiveStr","includeInExcel":true,"exportColumn":null,"displayName":"Is Active?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":2,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":true,"exportColumn":null,"displayName":"CanDelete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): ClientDetailVmFromFg {
		return new ClientDetailVmFromFg(fg);
	}
}

export class ClientDetailVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get clientId(): number {
		return this.fg.get('clientId').value;
	}
	set clientId(val) {
		this.fg.get('clientId').setValue(val);
	}

	get clientName(): string {
		return this.fg.get('clientName').value;
	}
	set clientName(val) {
		this.fg.get('clientName').setValue(val);
	}

	get isActiveStr(): string {
		return this.fg.get('isActiveStr').value;
	}
	set isActiveStr(val) {
		this.fg.get('isActiveStr').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
